module.exports = __webpack_public_path__ + "static/media/stolzl-regular.eb6319c0.woff";